import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../cx';
import type { Tone } from '../status';
import styles from './Badge.module.css';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
  icon?: ReactNode;
  /** `count` renders a compact numeric pill (nav / tab counts). */
  size?: 'md' | 'count';
  children: ReactNode;
}

export function Badge({ tone = 'neutral', icon, size = 'md', className, children, ...rest }: BadgeProps) {
  return (
    <span className={cx(styles.badge, styles[tone], size === 'count' && styles.count, className)} {...rest}>
      {icon}
      {children}
    </span>
  );
}
